import React from "react";
import { timelineData } from "./timelineData";
import Timelinetext from "./Timelinetext";
import Widthline from "./Widthline";
import CircleTimeline from "./CircleTimeline";
import CircleAnimation from "./CircleAnimation";
import { useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../../../utils/BaseUrl";


const Timeline = () => {
  const { data } = useQuery({
    queryKey: "gettimeline",
    queryFn: () =>
      axios.get(`${BASEURL}milestones`).then((res) => {
        return res?.data.data;
      }),
  });

  return (
    <div className="max-w-8xl mx-auto w-full py-20 grid grid-cols-9 px-2 relative">
      <div className="absolute inset-0 -z-10 opacity-50">
        <CircleAnimation />
      </div>
      {data?.map((item, index) => (
        <React.Fragment key={index}>
          {index % 2 === 0 && (
            <>
              <div className="col-span-4 w-full h-full "></div>
              <div className="relative col-span-1 w-full h-full flex justify-center items-center">
                <Widthline />
                <CircleTimeline />
              </div>
              <div className="col-span-4 w-full h-full">
                <Timelinetext
                  title={item.date}
                  description={item.archievement}
                />
              </div>
            </>
          )}

          {index % 2 !== 0 && (
            <>
              <div className="col-span-4 w-full h-full text-right">
                <Timelinetext
                  title={item.date}
                  description={item.archievement}
                />
              </div>
              <div className="relative col-span-1 w-full h-full flex justify-center items-center">
                <Widthline />
                <CircleTimeline />
              </div>
              <div className="col-span-4 w-full h-full "></div>
              {/* <Timelinetext title={item.title} description={item.description} /> */}
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Timeline;
